import { format, parseISO } from 'date-fns';
import { de, enUS, fr, it } from 'date-fns/locale';

export const parsedDate = (date: Date | string) =>
  typeof date === 'string' ? parseISO(date) : Date.parse(String(date));

export const formatDate = (date: Date | string | number, formatDate?: string, locale?: string) => {
  let targetLocale: Locale;
  switch (locale) {
    case 'en':
      targetLocale = enUS;
      break;
    case 'fr':
      targetLocale = fr;
      break;
    case 'it':
      targetLocale = it;
      break;
    default:
      targetLocale = de;
  }
  if (typeof date === 'number') {
    return format(date, formatDate || 'eee, dd.MM.yy', {
      locale: targetLocale,
    });
  }

  return parsedDate(date)
    ? format(parsedDate(date), formatDate || 'eee, dd.MM.yy', {
        locale: targetLocale,
      })
    : '';
};

export const getValueFromObjectByKey = (key: string) => (obj: object) => (obj && key && obj[key] ? obj[key] : null);

export const getValueFromProductByKeys = (key1: string, key2: string) => (productBasket: object, product: object) => {
  const valueBasketDate1 = getValueFromObjectByKey(key1)(productBasket);
  const valueProductDate1 = getValueFromObjectByKey(key2)(productBasket);

  const valueBasketDate2 = getValueFromObjectByKey(key1)(product);
  const valueProductDate2 = getValueFromObjectByKey(key2)(product);

  if (!!productBasket && (valueBasketDate1 || valueProductDate1)) {
    return parsedDate(valueBasketDate1 || valueProductDate1);
  } else if (!!product && (valueBasketDate2 || valueProductDate2)) {
    return parsedDate(valueBasketDate2 || valueProductDate2);
  } else {
    return null;
  }
};

export const getDataValuePairFromProductByKeys = (key1: string, key2: string) => (product: object) => {
  const date1 = getValueFromObjectByKey(key1)(product);
  const date2 = getValueFromObjectByKey(key2)(product);

  if (!!product && date1 && date2) {
    return [parsedDate(date1), parsedDate(date2)];
  }

  return null;
};

export const getBasketDateFromProduct = (product: object) =>
  getDataValuePairFromProductByKeys('basketstartdate', 'basketenddate')(product);

export const getDateFromProduct = (product: object) =>
  getDataValuePairFromProductByKeys('startdate', 'enddate')(product);

export const getStartDateFromProduct = (productBasket: object, product: object) =>
  getValueFromProductByKeys('basketstartdate', 'startdate')(productBasket, product);

export const getEndDateFromProduct = (productBasket: object, product: object) =>
  getValueFromProductByKeys('basketenddate', 'enddate')(productBasket, product);
